import React from 'react';
import AddCouponForm from 'app/form/AddCouponForm';

const AddCategory = () => {
	return (
		<div>
			<AddCouponForm />
		</div>
	);
};

export default AddCategory;
